import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { WebSocketContent } from '../models/webSocketContent';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notificacao',
  templateUrl: './notificacao.component.html',
  styleUrls: ['./notificacao.component.css']
})
export class NotificacaoComponent implements OnInit, OnDestroy {
  protocolo: string = null;
  timer: any;
  msg: string;
  ativo: boolean = false;
  numNotificacoes: number = 0;
  code: Number = null;
  hasOldNotification: boolean = false;
  listaNotificacoes: Array<_notificacao> = [];
  temNotificacoesNaoVistas: boolean = false;
  notificacoesAberta: boolean = false;
  @Input() habilitado: boolean;
  constructor(
    private app: AppComponent,
    private router: Router,
    private elementRef: ElementRef
  ) { }
  //este componente é o botão de notificação da parte inferior da tela
  //esse botão será responsável por notificar os usuários de alguma alteração no sistema
  //no momento que esse comentário esta sendo inserido a notificação só notifica sobre os chamados
  //mas podem ser adicionados novas notificações na função abaixo e também deve ser adicionado no app.component
  //para que a mensagem recebina no webSocket seja enviada no Subject notificação
  ngOnInit(): void {
    this.app.notificacao.subscribe((data: WebSocketContent) => {
      if (!(String(this.router.url).includes(data.content)))
        if (!this.ativo || data.content != this.protocolo) {
          this.ativo = true;
          if (data.code == 13) {
            this.protocolo = data.content;
            this.msg = 'Novo Chamado, Protocolo: ';
            this.code = 13;
          } else if (data.code == 14) {
            this.protocolo = data.content;
            this.msg = 'Nova Interação, Protocolo: '
            this.code = 14;
          } else if (data.code == 27) {
            this.protocolo = data.uuid_chamado;
            this.msg = 'Chamado Recebido: ';
            this.code = 27;
          }
          this.timer = setInterval(() => {
            this.temNotificacoesNaoVistas = true;
            this.desativar();
          }, 10000);
        }
        else { }
      let not: _notificacao = new _notificacao();
      not.hora = new Date().toLocaleTimeString().substring(0, 5);
      not.conteudo = this.retornaConteudo(data.code, data.content);
      not.protocolo = this.protocolo;
      this.listaNotificacoes.push(not);
    });
    document.addEventListener('click', this.documentClick.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.documentClick);
  }

  documentClick(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.notificacoesAberta = false; // Feche o card de notificações
    }
  }

  desativar() {
    this.ativo = false;
    this.msg = null;
    this.protocolo = null;
    this.code = null;
    clearInterval(this.timer);
  }

  click() {
    if (!this.ativo) return;
    if (this.code == 13 || this.code == 14 || this.code == 27) {
      this.router.navigate(['chamados/interacao/' + this.protocolo]);
    }
    this.desativar();
  }

  abrirNotificacoesAntigas() {
    this.temNotificacoesNaoVistas = false;
    this.notificacoesAberta = !this.notificacoesAberta;
  }

  retornaConteudo(code, protocolo) {//aqui são definidos as mensagens que seram exibidas nas notificações
    switch (code) {
      case (13): { return `Novo Chamado, Protocolo: ${protocolo}`; }
      case (14): { return `Nova Interação, Protocolo: ${protocolo}`; }
      case (15): { return `Nova Interação, Protocolo: ${protocolo}`; }
      case (27): { return `Nova Chamado, Protocolo: ${protocolo}`; }
      default: { return 'Falha ao carregar notificação'; }
    }
  }

  redirecionamentoChamado(protocolo) {
    this.notificacoesAberta = false;
    this.router.navigate(['chamados/interacao/' + protocolo]);
  }
}

export class _notificacao {
  conteudo: string;
  hora: string;
  protocolo: string;
}